import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProgramsHero } from '../components/programs/ProgramsHero';
import { ProgramsGrid } from '../components/programs/ProgramsGrid';
import { CTASection } from '../components/home/CTASection';
export function ProgramsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-917">
      <Header data-id="element-918" />

      <main className="pt-20" data-id="element-919">
        <ProgramsHero data-id="element-920" />
        <ProgramsGrid data-id="element-921" />
        <CTASection data-id="element-922" />
      </main>

      <Footer data-id="element-923" />
    </div>;
}